export default "__VITE_ASSET__bad43ad1__"